import {
  List,
  Paperclip,
  ListOrdered,
  Bold as TextBold,
  Italic as TextItalic,
  Underline as TextUnderline,
  Trash2,
  Download,
  FileIcon,
  Inbox,Image
} from "lucide-react";

function useLucideIcon() {
  return {
    List,
    Paperclip,
    ListOrdered,
    TextBold,
    TextItalic,
    TextUnderline,
    Trash2,
    Download,
    FileIcon,
    Inbox,Image
  };
}

export { useLucideIcon };
